import {BaseService} from './Core/BaseService';

class UserAPIKeyService extends BaseService {
    get Url() { return super.Url + "/apiKeys"; }

    GetApiKeys() {
        return this.SendRequest(BaseService.GET);
    }

    CreateApiKey(name) {
        return this.SendRequest(BaseService.POST, { name });
    }

    RevokeApiKey(userApiKeyId) {
        return this.SendRequest(BaseService.DELETE, userApiKeyId);
    }
}

export const service = new UserAPIKeyService();
